<div
  class="task"
  [id]="task().id"
  [ngStyle]="taskStyle()"
  [ngClass]="{ enable: task().enable }"
  (click)="onTaskClick($event, task(), false)"
  (dblclick)="onTaskClick($event, task(), true)"
  (mouseenter)="taskHover.emit(task())"
  (mouseleave)="taskHover.emit(null)"
>
  @if (canResizeLeft()) {
    <div class="resize" (mousedown)="resize($event, task(), 'left')">
      <span class="fal fa-ellipsis-v"></span>
    </div>
  }

  <div
    class="background"
    [ngStyle]="{
      'background-color':
        task().backgroundColor.length === 9
          ? task().backgroundColor
          : task().backgroundColor + 'BF',
    }"
  ></div>

  <div class="text" [ngClass]="{ 'no-resize': !canResize() || !task().enable }">
    @if (task().icon) {
      <span class="icon fal fa-{{ task().icon }}"></span>
    }
    <div class="text-content" [innerHTML]="task().label"></div>
  </div>

  @if (canResizeRight()) {
    <div class="resize right" (mousedown)="resize($event, task(), 'right')">
      <span class="fal fa-ellipsis-v"></span>
    </div>
  }
</div>
